/**
 * This component is shown during the initial sign up process.
 * It may also be needed when a resigning is required.
 */
<template>
  <div>
    <div v-if="!hasErrorInAgreement" class="content-width">

      <sh-spacer :by="1"/>

      <el-alert
        title="Please read and agree to the terms and conditions"
        type="info"
        show-icon>
      </el-alert>

      <sh-spacer :by="3"/>

      <LicenseRenderer
        :licenseName="licenseName"
        :form="formDefinition"
        @input="handleLicenseUpdate"
      />

      <sh-spacer :by="2"/>

      <div style="text-align: right;">
        <el-button
          :disabled="!this.form['terms-and-conditions']"
          :loading="loading"
          type="primary"
          @click="submit"
        >
          Agree
        </el-button>
      </div>
      <sh-spacer :by="4"/>
    </div>
    <Fallback v-else />
  </div>
</template>

<script>
import webcall from '@/libs/webcall';
import licenseParentMixin from '../mixins/licenseParentMixin';
import LicenseRenderer from '../CommonLicenseComponents/LicenseRenderer';

export default {
  mixins: [
    licenseParentMixin,
  ],
  components: {
    LicenseRenderer,
  },
  props: {
    licenseName: {
      type: String,
      required: true,
    },
    formField: {
      type: Object,
      required: true,
    },
    specification: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      form: licenseParentMixin.functionalMethods.generateFormData(this.$options.propsData.formField),
      loading: false,
    };
  },
  computed: {
    agreement() {
      return this.$store.state.agreement;
    },
    formDefinition() {
      return licenseParentMixin.functionalMethods.generateFormDefinition(
        this.$options.propsData.formField,
        this,
        'form',
      );
    },
  },
  methods: {
    handleLicenseUpdate([fieldname, fieldValue]) {
      // This will handle the update for primitive value
      // Complex object such as film details and filmmaker are handled by mutating inner properties of object
      // (This is not the best way, if you have time to implement a proper solution, consider doing it.)
      this.form[fieldname] = fieldValue;
    },

    submit() {
      this.loading = true;
      if (!this.form['terms-and-conditions']) {
        return;
      }
      webcall.agreement.sign(this.form)
        .then(() => this.$store.dispatch('account/initialiseAccount'))
        .then(() => {
          this.loading = false;
          this.$router.push('/');
        })
        .catch((error) => {
          this.loading = false;
          throw error;
        });
    },
  },
};
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/Licenses/FilmLicenseAgreementIntro/AgreementIntroPage.vue